import styles from './style.module.css';
import Modal from 'react-responsive-modal';
import sucess from '../../../../assets/images/step-4.png';
import { useAuth } from '../../../../hooks/useAuth';

interface IModalHasSucced {
  modalIsOpen: boolean;
  correctAnswers: number;
  earnedPoints: number;
  toggleModal: () => void;
}

export function ModalHasSucced({
  modalIsOpen,
  correctAnswers,
  earnedPoints,
  toggleModal,
}: IModalHasSucced) {
  const { client } = useAuth();
  return (
    <Modal
      open={modalIsOpen}
      onClose={() => {
        toggleModal();
      }}
      center
    >
      <div className={styles.contents}>
        <div className="d-flex justify-content-center">
          <img className={styles.alert} src={sucess} alt="" />
        </div>
        <h1 className={styles.title}>
          <b className={styles.highlightText}>Parabéns!!!</b> Você respondeu{' '}
          <b className={styles.highlightText}>{correctAnswers}</b> pergunta
          {correctAnswers !== 1 && 's'} correta{correctAnswers !== 1 && 's'} e
          ganhou <b className={styles.highlightText}>{earnedPoints}</b>{' '}
          {earnedPoints === 1
            ? `${client?.coinName ? client.coinName.replace(/\(\w*\)/g, '') : 'ponto'}`
            : `${client?.coinName ? client.coinName.replace(/\((\w+)\)/, (_, conteudo) => conteudo) : 'pontos'}`}
          !
        </h1>
      </div>
      <div className={styles.contentBtn}>
        <button
          onClick={() => {
            toggleModal();
          }}
          className={styles.btnAgree}
          type="button"
        >
          Ver pontuação
        </button>
      </div>
    </Modal>
  );
}
